// extracted by mini-css-extract-plugin
export default {"modal":"SavePositionTemplateModal-module__modal__PJAFg","content":"SavePositionTemplateModal-module__content__hYBtF"};